import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Divider,
    Grid,
    Stack,
    Typography,
} from '@mui/material';

import { Users } from './Users';

// const colorCard = {
//     'CAJA ADMINISTRATIVA': '#B18A46',
//     'CAJA CHICA': '#697078',
//     'CAJA CENTRAL': '#8B5E34',
// }

export const Cashiers = ({ useFetchInit, dataCashiers, category }) => {

    const { Actions } = useFetchInit
    const { abrirModal } = Actions

    return (
        <>
            {dataCashiers.map((cashier) => {
                const dataUsers = cashier.usuarios ?? [];

                return (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={4}
                        key={cashier.idcaja}
                    >
                        <Card
                            variant="outlined"
                            sx={{
                                height: '100%',
                                // borderTop: `4px solid ${colorCard[category]}`,
                                borderTop: `4px solid #B18A46`,
                                borderRadius: 2,
                            }}
                        >
                            <CardContent
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <Typography variant="h6" fontWeight={700}>
                                    {cashier.nombre?.trim()}
                                </Typography>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    sx={{ mt: 1, flexWrap: 'wrap' }}
                                >
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {dataUsers.length}{' '}
                                        {dataUsers.length === 1
                                            ? 'usuario asignado'
                                            : 'usuarios asignados'}
                                    </Typography>

                                    {cashier.currency_type && (
                                        <Chip
                                            size="small"
                                            variant="filled"
                                            color={
                                                cashier.currency_type === 'DOLAR'
                                                ? 'success'
                                                : 'primary'
                                            }
                                            label={
                                                cashier.currency_type === 'DOLAR'
                                                ? 'Dólares'
                                                : 'Quetzales'
                                            }
                                        />
                                    )}
                                </Stack>

                                <Users dataUsers={dataUsers}/>

                                <Divider sx={{ mb: 1.5 }} />

                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        size="small"
                                        color="inherit"
                                        onClick={() => abrirModal(
                                            '',
                                            cashier.nombre?.trim(),
                                            'UserList',
                                            cashier
                                        )}
                                    >
                                        Ver usuarios
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                );
            })}
        </>
    )
}
